export const hasEndpointAccess = (user, identifier, method = 'GET') => {
  if (!user) return false;
  if (user.is_superuser) return true;

  const normalizedMethod = method.toUpperCase();
  const endpoints = user.allowed_endpoints || [];
  const normalizeIdentifier = (value) => {
    if (!value) return '';
    const parts = String(value).split(':');
    return parts[parts.length - 1];
  };
  const requiredHasNamespace = String(identifier || '').includes(':');
  const requiredIdentifier = normalizeIdentifier(identifier);

  return endpoints.some((endpoint) => {
    if (!endpoint) return false;
    const endpointMethod = (endpoint.method || endpoint.http_method || '').toUpperCase();
    const endpointIdentifier = endpoint.identifier || '';
    const normalizedEndpointIdentifier = normalizeIdentifier(endpointIdentifier);
    const identifierMatches =
      endpointIdentifier === identifier ||
      (!requiredHasNamespace && normalizedEndpointIdentifier === requiredIdentifier);
    
    // 1. Exact match
    if (identifierMatches && (endpointMethod === normalizedMethod || endpointMethod === 'ANY')) {
      return true;
    }

    // 2. Wildcard match (e.g. "admin-fulfillment-*" allows "admin-fulfillment-requests-list")
    if (endpointIdentifier && endpointIdentifier.endsWith('*')) {
      const fullPrefix = endpointIdentifier.slice(0, -1);
      const normalizedPrefix = normalizeIdentifier(endpointIdentifier).slice(0, -1);
      const wildcardMatches = requiredHasNamespace
        ? String(identifier || '').startsWith(fullPrefix)
        : requiredIdentifier.startsWith(normalizedPrefix);

      if (wildcardMatches) {
        return endpointMethod === 'ANY' || endpointMethod === normalizedMethod;
      }
    }

    return false;
  });
};

export const hasAnyEndpointAccess = (user, checks = []) => {
  if (!user) return false;
  if (user.is_superuser) return true;
  if (!checks.length) return true;
  return checks.some(({ identifier, method }) => hasEndpointAccess(user, identifier, method));
};

export const buildEndpointMap = (allowed = []) => {
  return allowed.reduce((acc, endpoint) => {
    if (!endpoint) return acc;
    const method = (endpoint.method || endpoint.http_method || 'ANY').toUpperCase();
    const key = `${endpoint.identifier}:${method}`;
    acc[key] = true;
    return acc;
  }, {});
};

